<template>
  <div
    class="admin-draft-preview-approval-actions d-flex flex-column flex-md-row align-md-center flex-wrap"
    :class="{ 'admin-draft-preview-approval-actions--compact': compact }"
  >
    <v-btn
      color="success"
      variant="tonal"
      prepend-icon="mdi-check-circle"
      :size="compact ? undefined : 'large'"
      :loading="pending"
      :disabled="!canApproveClose"
      @click="$emit('approve', 'close')"
    >
      Approve & close
    </v-btn>
    <v-btn
      color="primary"
      prepend-icon="mdi-arrow-right"
      :size="compact ? undefined : 'large'"
      :loading="pending"
      :disabled="!canApproveNext"
      @click="$emit('approve', 'next')"
    >
      Approve & next
    </v-btn>
    <v-alert
      v-if="completionRecovery"
      type="warning"
      variant="tonal"
      density="compact"
      border="start"
      class="ma-0 flex-grow-1"
    >
      <div>The draft was approved, but navigation or close failed.</div>
      <v-btn
        variant="text"
        color="primary"
        class="mt-1"
        @click="$emit('recover')"
      >
        Return to drafts
      </v-btn>
    </v-alert>
    <v-alert
      v-if="!approvalReady"
      type="info"
      variant="tonal"
      density="compact"
      border="start"
      class="ma-0 flex-grow-1"
    >
      <div>Cannot approve yet. Complete all validation checks.</div>
      <div class="text-caption mt-1">
        Return to the admin edit page to resolve outstanding items.
      </div>
      <div v-if="issues.length" class="text-caption mt-1">
        Outstanding: {{ issues.join(" ") }}
      </div>
    </v-alert>
  </div>
</template>

<script setup>
defineProps({
  pending: Boolean,
  canApproveClose: Boolean,
  canApproveNext: Boolean,
  completionRecovery: {
    type: Object,
    default: null,
  },
  approvalReady: Boolean,
  issues: {
    type: Array,
    default: () => [],
  },
  compact: Boolean,
});

defineEmits(["approve", "recover"]);
</script>

<style scoped lang="scss">
.admin-draft-preview-approval-actions {
  gap: 16px;

  &--compact {
    gap: 8px;
  }
}
</style>
